import type { SpacesConfigLabels } from '@/types/api'
import { linkTargetProps } from '@/utils/linkTarget'

type DisclaimerLink = SpacesConfigLabels['disclaimerLink']

interface DisclaimerProps {
	text: string
	link?: DisclaimerLink
	variant: 'top' | 'bottom'
	className?: string
}

/**
 * Renders a top or bottom disclaimer with an optional CMS-configured link
 * appended after the text. Renders nothing when text is empty, matching the
 * gating used across the app.
 */
export function Disclaimer ({ text, link, variant, className }: DisclaimerProps) {
	if (!text) return null

	const classes = [
		'spaces-disclaimer',
		`spaces-disclaimer-${variant}`,
		'spaces:text-12/14',
		'spaces:italic',
		'spaces:text-content-3',
		className
	].filter(Boolean).join(' ')

	return (
		<p className={classes}>
			{text}
			{link && link.url && (
				<>
					{' '}
					<a
						className='spaces-disclaimer-link spaces:text-brand-base spaces:underline spaces:hover:text-brand-hover'
						href={link.url}
						{...linkTargetProps(link.target)}
					>
						{link.title || link.url}
					</a>
				</>
			)}
		</p>
	)
}
